module.exports = __webpack_public_path__ + "2f9f32c714f143a486135d32c1b74a1c.svg";